import { render, staticRenderFns } from "./CompetenceTypeForm.vue?vue&type=template&id=779698c8&scoped=true"
import script from "./CompetenceTypeForm.vue?vue&type=script&lang=js"
export * from "./CompetenceTypeForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=779698c8&prod&scoped=true&lang=css&external"
import style1 from "./CompetenceTypeForm.vue?vue&type=style&index=1&id=779698c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779698c8",
  null
  
)

export default component.exports